<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog persistent v-model="showClientInvoiceModal" scrollable :max-width="1200" @close="close">
            <v-card>
                <v-card-title>
                    <span class="headline">Faturas do Cliente: {{selectedClient.name}}</span>
                </v-card-title>
                
                <v-divider></v-divider>
                <v-card-text  class="mx-0, px-0">
                    <v-container>
                        <v-data-table
                            :headers="clientInvoiceHeaders"
                            :items="clientInvoices"
                            :loading="loadingClientInvoices"
                            class="elevation-1"
                            :no-data-text="loadingClientInvoices ? 'a carregar...' : 'Nenhuma fatura ainda para o cliente: '+selectedClient.name"
                            :no-results-text="'nenhum resultado'"
                            rows-per-page-text="por página"
                            disable-initial-sort
                        >
                            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.item.code ? props.item.code+'/'+props.item.series : 'Fatura programada'}}<span style="color: red; font-size: 11px">{{props.item.types_operation_type_id === Types.operation_type.ANULADO ? ' (anulado)' : ''}}</span></td>
                                <td class="text-xs-right">{{ props.item.emission_date | formatDate}}</td>
                                <td class="text-xs-right">{{ props.item.due_date | formatDate}}</td>
                                <td class="text-xs-right">{{ props.item.total_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                <td class="text-xs-right">{{props.item.pendent_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                                <td class="text-xs-right" style="max-width: 200px">
                                    <v-flex >
                                        <v-text-field
                                            v-model="props.item.introduced_value"
                                            :disabled="!props.item.enablePayment"
                                            :min="0"
                                            :max="props.item.pendent_value"
                                            label="A pagar"
                                            type="number"
                                            @input="fixInputValue(props.item)"
                                        >{{props.item.introduced_value}}</v-text-field>
                                    </v-flex>
                                </td>
                                <td class="text-xs-right"  style="max-width: 200px">
                                    <v-flex>
                                        <v-select v-model="props.item.payment_method"
                                            :items="paymentMethods"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="!props.item.code || props.item.pendent_value <= 0 || props.item.types_operation_type_id === Types.operation_type.ANULADO"
                                            label="Método Pagamento"
                                        ></v-select>
                                    </v-flex>
                                </td>
                                <td style="width: 40px">
                                    <v-checkbox
                                        :value="props.item.introduced_value > 0 && props.item.enablePayment"
                                        :key="props.index"
                                        :label="'pagar'"
                                        primary
                                        :disabled="!props.item.code || props.item.pendent_value <= 0 || props.item.types_operation_type_id === Types.operation_type.ANULADO"
                                        hide-details
                                        @change="verifyChange(props.item)"
                                    ></v-checkbox>
                                </td>
                            </template>
                        </v-data-table>

                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loadingClientInvoices">
                        <v-btn depressed @click="close">Cancelar</v-btn>
                        <v-btn v-if="!loadingPayingInvoice" :disabled="invoicesToBePaid.length < 1 || loadingPayingInvoice" color="primary"
                            @click="payInvoices()">Pagar & Emitir Fatura</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Receipt paper-->
        <receipt-paper></receipt-paper>

    </div>
</template>


<script>
    import Vue from "vue";
    import _ from 'lodash';
    import {eventBus} from "../../main";
    import {mapGetters} from 'vuex';
    import {Types, Global} from "../../config";
    import {maxLength, required,} from 'vuelidate/lib/validators'
    import ReceiptPaper from '../receipt/ReceiptPaper';
    export default {
        name: "FormModal",

        beforeDestroy(){
            this.close();
        },

        data () {
            return {
                Global,
                Types,
                active_tab: 0,
                loading_modal: false,

                //company form modal needed attributes
                clientInvoices: [],
                invoicesToBePaid: [],
                // cities: [],


                clientInvoiceHeaders: [
                    { text: 'Código Fatura', align: 'left', value: 'code' },
                    { text: 'Emissão', align: 'center', value: 'emission_date' },
                    { text: 'Vencimento', align: 'right', value: 'due_date' },
                    { text: 'Total', align: 'right', value: 'total_value' },
                    { text: 'Pendente', align: 'right', value: 'pendent_value' },
                    { text: 'Valor', align: 'right', value: 'introduced_value', sortable: false },
                    { text: 'Met. Pag', align: 'right', value: 'payment_method', sortable: false },
                    { text: '', sortable: false },
                ],

                //AutoComplete
                loadingClientInvoices: false,

                loadingPayingInvoice: false,
            }
        },



        props: {
            paymentMethods: Array,
            simplifiedModal: {
                type: Boolean,
                default: false
            },
        },

        validations: {
            formClient: {
                
                active_state: {
                    required,
                },
                website: {
                    maxLength: maxLength(100),
                },
                description: {
                    maxLength: maxLength(250),
                }
            }

        },

        components: {
            ReceiptPaper,
        },

        watch: {
            showClientInvoiceModal(){
                if(this.showClientInvoiceModal){
                    this.onClientInvoiceModalOpened();
                }
            },

        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'isLoggedUserSuperAdmin',
                'getToken'
            ]),
            
            showClientInvoiceModal: {
                get() { return this.$store.getters.getShowClientInvoiceModal },
                set(value) { this.$store.dispatch('setShowClientInvoiceModal', value); },
            }, 

            selectedClient: {
                get(){ return this.$store.getters.getSelectedClient; },
                set(value){ this.$store.dispatch('setSelectedClient', value); }
            },
            showReceiptPaperModal: {
                get() { return this.$store.getters.getShowReceiptPaperModal; },
                set(value) { this.$store.dispatch('setShowReceiptPaperModal', value); }
            },
            selectedReceipt: {
                get() { return this.$store.getters.getSelectedReceipt; },
                set(value) { this.$store.dispatch('setSelectedReceipt', value); }
            },
            selectedInvoice: {
                get(){ return this.$store.getters.getSelectedInvoice; },
                set(value){ this.$store.dispatch('setSelectedInvoice', value); }
            },
        },

        methods: {
            
            onClientInvoiceModalOpened(){
                this.consoleLog("onClientInvoiceModalOpened");
                this.getClientInvoices();
                
            },

            verifyChange(invoiceToPay){

                invoiceToPay.enablePayment = !invoiceToPay.introduced_value;
                invoiceToPay.introduced_value = invoiceToPay.enablePayment ? invoiceToPay.pendent_value : 0

                this.checkInvoicesToBePaid();                
            },

            fixInputValue(invoiceToPay){
                this.consoleLog('fixInputValue: ', invoiceToPay.introduced_value);

                if(invoiceToPay.introduced_value < 1) {
                    let mIndex = -1;
                    for(let i=0; i<this.invoicesToBePaid.length; i++){
                        if(invoiceToPay.id === this.invoicesToBePaid[i].id) mIndex = i;
                    }
                    if(mIndex > -1) this.invoicesToBePaid.splice(mIndex,1);
                }else{
                    this.checkInvoicesToBePaid();
                }
            },

            checkInvoicesToBePaid(){
                this.invoicesToBePaid = [];
                for (let i = 0; i < this.clientInvoices.length; i++) {
                    let invoice = this.clientInvoices[i];
                    if(invoice.introduced_value > 0){
                        this.invoicesToBePaid.push(invoice);
                    }
                }
                return this.invoicesToBePaid;
            },


            getClientInvoices(){
                this.consoleLog("getClientInvoices");
                this.loadingClientInvoices = true;
                Vue.axios.get('client/invoices/'+this.selectedClient.id, {

                }).then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.loadingClientInvoices = false;
                        this.handleErrorCodeMessage(response.data);
                        return;
                    }

                    this.clientInvoices = response.data.response.invoices;
                    for (let i = 0; i < this.clientInvoices.length; i++) {
                        this.clientInvoices[i].introduced_value = 0; //setting the initial introduced value as zero
                        this.clientInvoices[i].payment_method = this.paymentMethods[1]; //setting the initial payment method as [Money]
                    }

                }).catch(error => {

                }).finally(()=>{
                    this.loadingClientInvoices = false;
                })
            },

            checkValueToBePaid(){
                if(!this.invoicesToBePaid || this.invoicesToBePaid.length < 1){
                    this.showSnackBar('Nenhuma fatura foi seleciona.');
                    return false;
                }
                for (let i = 0; i < this.invoicesToBePaid.length; i++) {
                    let invoice = this.invoicesToBePaid[i];
                    if(invoice.introduced_value > invoice.pendent_value){
                        this.showSnackBar("O valor introduzido é superior ao valor pendente");
                        return false;
                    }else if(!invoice.introduced_value || invoice.introduced_value < 1){
                        this.showSnackBar('Por introduza um valor superior a zero');
                        return false;
                    }
                }

                return true;
            },

            payInvoices(){
                this.consoleLog('Start paying multiple invoices at once');
                if(!this.checkValueToBePaid()) return false;

                this.loadingPayingInvoice = true;
                Vue.axios.post('client/pay_invoices/'+this.selectedClient.id, {
                    'invoices': JSON.stringify(this.invoicesToBePaid),
                }).then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.showSnackBar('Erro ao carregar lista de faturas do client '+this.selectedClient.name);
                        eventBus.$emit('onInvoicesPaid', 'Erro ao liquidar faturas', 'error');
                        return;
                    }

                    let invoices = response.data.response.invoices;
                    for (let i = 0; i < this.clientInvoices.length; i++) {
                        this.clientInvoices[i].introduced_value = 0;
                        for (let j = 0; j < invoices.length; j++) {
                            if(this.clientInvoices[i].id === invoices[j].id){
                                this.clientInvoices[i].pendent_value = invoices[j].pendent_value;
                                this.clientInvoices[i].introduced_value = 0;
                                // this.clientInvoices.splice(i, 0, invoices[j]);
                                this.selectedReceipt = response.data.response.receipt;
                                try {
                                    this.selectedInvoice = response.data.response.invoices[0];
                                    // this.consoleLog(this.selectedInvoice);
                                }catch (e) {
                                    this.consoleLog(e);
                                }
                            }
                        }
                    }
                    this.showReceiptPaperModal = true;
                    eventBus.$emit('onReceiptPaperOpen');
                    this.close();
                    eventBus.$emit('onInvoicesPaid', 'Faturas liquidadas com successo', 'success');

                }).catch(error => {
                    this.consoleLog(error);
                    eventBus.$emit('onInvoicesPaid', 'Erro ao liquidar faturas', 'error');
                }).finally(()=>{
                    this.loadingPayingInvoice = false;
                })
            },

            close () {
                this.showClientInvoiceModal = false;
                this.invoicesToBePaid = [];
                this.clientInvoices = [];
                this.loadingPayingInvoice = false;
            },

        }
    }
</script>